import { OnboardingLayout } from "@/layouts";
import { IoLogIn } from "react-icons/io5";
import { Link } from "react-router-dom";
import "./style.scss";

const NotFoundPage = () => {
  return (
    <OnboardingLayout>
      <div className="not-found-page">
        <div className="not-found-page__title">
          <h3>Not Found</h3>
        </div>
        <div className="not-found-page__body mt-4">
          <div>Sorry, the page you are looking for does not exist.</div>
          <div>
            Please, go back to the{" "}
            <Link to="/">
              <IoLogIn />
              Sign up
            </Link>
            .
          </div>
        </div>
      </div>
    </OnboardingLayout>
  );
};

export default NotFoundPage;
